module.exports = __webpack_public_path__ + "img/kanban.b21d1254.svg";